module.exports = __webpack_public_path__ + "img/item1.8d602823.png";